import { RunningTradeEmptyText, RunningTradeEmptyWrapper } from './styled';

const RunningTradeEmpty = () => {
  const icon = (
    <svg
      width="160"
      height="121"
      viewBox="0 0 160 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.9492 29.2016H118.049C119.149 29.2016 120.049 30.1016 120.049 31.2016V50.1416H39.9492V31.2016C39.9492 30.1016 40.8492 29.2016 41.9492 29.2016Z"
        fill="#E6FCEF"
      />
      <path
        d="M118.049 29.2016H41.9492C40.8446 29.2016 39.9492 30.097 39.9492 31.2016V90.0916C39.9492 91.1962 40.8446 92.0916 41.9492 92.0916H118.049C119.154 92.0916 120.049 91.1962 120.049 90.0916V31.2016C120.049 30.097 119.154 29.2016 118.049 29.2016Z"
        stroke="#00AB6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.9102 29.2016V92.0816"
        stroke="#00AB6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.9492 50.1416H120.049"
        stroke="#00AB6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.9492 71.0816H120.049"
        stroke="#00AB6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5195 71.0816H119.48"
        stroke="#00AB6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7791 38.5716C18.9891 38.5716 20.7691 36.7916 20.7691 34.5816C20.7691 32.3716 18.9891 30.5916 16.7791 30.5916C14.5691 30.5916 12.7891 32.3716 12.7891 34.5816C12.7891 36.7916 14.5691 38.5716 16.7791 38.5716Z"
        stroke="#00AB6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.7094 16.7516C34.2794 16.7516 35.5594 15.4816 35.5594 13.9016C35.5594 12.3216 34.2894 11.0516 32.7094 11.0516C31.1294 11.0516 29.8594 12.3216 29.8594 13.9016C29.8594 15.4816 31.1294 16.7516 32.7094 16.7516Z"
        stroke="#00AB6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M135.18 107.162C137.72 107.162 139.77 105.112 139.77 102.572C139.77 100.032 137.72 97.9816 135.18 97.9816C132.64 97.9816 130.59 100.032 130.59 102.572C130.59 105.112 132.64 107.162 135.18 107.162Z"
        stroke="#00AB6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M127.471 39.8516C130.221 41.3516 133.891 40.9116 136.211 38.8216C138.531 36.7316 139.341 33.1216 138.131 30.2316C137.721 29.2516 137.051 28.3216 136.091 27.8716C135.131 27.4216 133.821 27.6216 133.221 28.5016C132.761 29.1816 132.811 30.1216 133.191 30.8416C133.571 31.5616 134.241 32.1016 134.961 32.5016C137.661 33.9916 141.141 33.6216 143.751 32.0016C146.361 30.3816 148.161 27.6516 149.131 24.7216"
        stroke="#00AB6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M149.861 21.0416C150.311 19.3116 149.901 17.6616 149.901 17.6616"
        stroke="#00AB6B"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <RunningTradeEmptyWrapper>
      {icon}
      <RunningTradeEmptyText>Data belum tersedia</RunningTradeEmptyText>
    </RunningTradeEmptyWrapper>
  );
};
export default RunningTradeEmpty;
